module.exports = __webpack_public_path__ + "static/onetower-sm-1ad6cb1f7d09653904c4a26596bb35cc.jpg";